export const COMPONENT_NAME = 'ItineraryMap';
